const trackingDownloadForm = () => {
  $(".js-tracking-download").on("click", function() {
    $.ajax({
      url: "/api/v1/experiment/track?name=download_on_form_page",
      xhrFields: {
        withCredentials: true
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
  });
};

$(document).ready(function() {
  trackingDownloadForm();
});
